import { RouteComponentProps } from '@reach/router';
import { PureComponent } from 'react';
import { connect, MapDispatchToProps } from 'react-redux';
import {
  AvatarAndNameWrapper,
  HeaderContent,
  Name,
  UserAvatar,
  Banner,
} from './styles';
import BG from '../../../../assets/images/homepage/Image.png';
import { IProvider } from 'store/providers/providerTypes';

interface IDispatchToProps {}

interface IComponentStates {}
interface IOwnProps {
  provider: IProvider;
  small?: boolean;
}

interface IStateToProps {}

type IComponentProps = IDispatchToProps & IStateToProps & IOwnProps;

class HomeHead extends PureComponent<IComponentProps, IComponentStates> {
  render() {
    const { provider, small } = this.props;
    const profilePictureDoc = provider.documents.find(
      (it) => it.document?.documentType === 'profile_picture'
    );

    return (
      <div>
        <HeaderContent>
          <Banner src={BG} small={small} />
          <AvatarAndNameWrapper>
            {profilePictureDoc && (
              <UserAvatar src={profilePictureDoc.document?.url} alt="avatar" />
            )}
            <Name white={true}>{provider.name}</Name>
          </AvatarAndNameWrapper>
        </HeaderContent>
      </div>
    );
  }
}

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  RouteComponentProps
> = () => {
  return {};
};

export default connect(null, mapDispatchToProps)(HomeHead);
